import { type CacheConfig, Cache } from "@tutellus/decorators"
import { Config } from "../../_config/index.js"
import { UseCase } from "../../_kernel/architecture.js"
import { GQLProjectRepository } from "../Repositories/GQLProjectRepository/index.js"
import { ProjectConfig } from "../Models/ProjectConfig.js"

export class GetConfigProjectService implements UseCase<void, ProjectConfig> {
  static create({ config }: { config: Config }) {
    return new GetConfigProjectService(GQLProjectRepository.create(config))
  }

  constructor(private readonly repository: GQLProjectRepository) {}

  @Cache({
    name: "GetConfigProjectService",
    ttl: Number.MAX_SAFE_INTEGER,
    references: () => {
      return ["project:config"]
    },
  } as const as CacheConfig<ProjectConfig>)
  async execute(): Promise<ProjectConfig> {
    const config = await this.repository.getProjectConfig()

    return config
  }
}
